<template>
  <div class="panel-wrapper">
    <div class="content">
      <mobile-header>
        <template #arrowLeft>
          <i class="el-icon-arrow-left" @click="$emit('hideGrade')"></i>
        </template>
        <template #title>
          <span class="text">年级选择</span>
        </template>
      </mobile-header>

      <div class="scroll-area">
        <grade 
          class="grade" 
          :grade="grade" 
          @setGrade="setGrade"
        />
      </div>

      <div class="btn-wrapper">
        <button class="btn-cancel" @click="$emit('hideGrade')">取 消</button>
        <button class="btn-confirm" @click="selectGrade">确 定</button>
      </div>
    </div>
  </div>
</template>

<script>
import MobileHeader from './MobileHeader.vue';
import Grade from '../user/grade.vue';   // 指向上面新建的 grade.vue
import { updateGrade } from "@/api/home";

export default {
  name: 'gradePanel',
  components: { MobileHeader, Grade },
  props: {
    grade: { type: String, default: "" }
  },
  data() {
    return { selectedGrade: "" };
  },
  watch: {
    grade: {
      immediate: true,
      handler(val) { this.selectedGrade = val; }
    }
  },
  methods: {
    async updateGrade() {
      const selectedGrade = this.selectedGrade;
      const res = await updateGrade({ grade: selectedGrade });
      this.$emit('hideGrade');
      if (res.status === 200) {
        this.$message.success(res.data.message);
        this.$store.commit("setUser", { grade: selectedGrade });
        this.$store.commit("setLevel", selectedGrade);
      } else {
        this.$message.error("更新年级身份信息失败！");
      }
    },
    selectGrade() { this.updateGrade(); },
    setGrade(grade) { this.selectedGrade = grade; }
  }
};
</script>

<style lang="scss" scoped>
$transition-base: all 0.2s ease;
$border-radius-card: 20px;
$border-radius-btn: 40px;

.panel-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 101;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
}

.content {
  background: #ffffff;
  border-radius: 18px 18px 0 0;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
}

.scroll-area {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 20px 16px 8px 16px;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
}

// grade 组件自身已包含完整样式，无需额外深度覆盖
.grade {
  width: 100%;
}

.btn-wrapper {
  padding: 16px 20px calc(20px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  
  button {
    flex: 1;
    padding: 12px 0;
    font-size: 16px;
    font-weight: 600;
    border-radius: $border-radius-btn;
    border: none;
    transition: $transition-base;
    cursor: pointer;
    &:active {
      transform: scale(0.97);
    }
  }
  .btn-cancel {
    background: #f2f4f8;
    color: #5a6874;
    &:hover { background: #e9ecef; }
  }
  .btn-confirm {
    background: linear-gradient(135deg, #4a90e2, #7b68ee);
    color: white;
    box-shadow: 0 4px 10px rgba(74,144,226,0.3);
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(74,144,226,0.35);
    }
  }
}

@media (min-width: 750px) {
  .panel-wrapper {
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    .content {
      width: 600px;
      max-height: 80vh;
      border-radius: 32px;
      margin: 0 auto;
    }
    .scroll-area {
      padding: 24px;
    }
    .btn-wrapper {
      border-radius: 0 0 32px 32px;
    }
  }
}

@media (max-width: 360px) {
  .scroll-area {
    padding: 16px 12px 8px;
  }
  .btn-wrapper {
    padding: 12px 16px calc(16px + env(safe-area-inset-bottom, 0px));
    button {
      padding: 10px 0;
      font-size: 14px;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .content {
    background: #1e293b;
  }
  .scroll-area {
    background: #1e293b;
  }
  .btn-wrapper {
    background: #1e293b;
    border-top-color: #2d3a4e;
    .btn-cancel {
      background: #2d3a4e;
      color: #cbd5e1;
      &:hover { background: #3a4a62; }
    }
  }
}

:deep(.mobile-header) {
  padding: 20px 16px 8px;
  flex-shrink: 0;
  .arrow-left i {
    font-size: 24px;
    transition: $transition-base;
    &:active { transform: scale(0.9); }
  }
  .title .text {
    font-size: 20px;
    font-weight: 700;
    background: linear-gradient(135deg, #4a90e2, #7b68ee);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
}
</style>